var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9974 11.9986C14.9974 13.7224 13.653 15.1197 11.9946 15.1197C10.3362 15.1197 8.99177 13.7224 8.99177 11.9986C8.99177 10.2749 10.3362 8.87751 11.9946 8.87751C13.653 8.8775 14.9974 10.2749 14.9974 11.9986ZM12 5.5C10.2829 5.50826 8.50311 5.96177 6.81827 6.83004C5.56731 7.50126 4.34816 8.44828 3.2899 9.61716C2.77013 10.2138 2.10718 11.0778 2 11.9996C2.01267 12.7982 2.80217 13.7837 3.2899 14.3821C4.28228 15.5051 5.46967 16.4257 6.81827 17.17C8.38945 17.9972 10.1285 18.4735 12 18.5C13.7187 18.4916 15.4981 18.0329 17.1811 17.17C18.4321 16.4987 19.6519 15.551 20.7101 14.3821C21.2299 13.7855 21.8928 12.9215 22 11.9996C21.9873 11.2011 21.1979 10.2155 20.7101 9.61714C19.7177 8.49414 18.5297 7.57427 17.1811 6.83C15.6108 6.00338 13.8674 5.53036 12 5.5ZM11.9987 7.11376C14.6007 7.11376 16.71 9.30153 16.71 12.0004C16.71 14.6992 14.6007 16.8869 11.9987 16.8869C9.39675 16.8869 7.28748 14.6991 7.28748 12.0004C7.28748 9.30153 9.39675 7.11376 11.9987 7.11376Z",
    fill: "#C6CCFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenEye);
export default __webpack_public_path__ + "static/media/open-eye.bc68ada7ee09c7237b9c0a97cf154faa.svg";
export { ForwardRef as ReactComponent };